// CacheKey 05e390ff058fd08d587d0d986cd5331a
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-SUFFOLK_CARE_COLLABORATIVE": {
    filters: {
      arrival: {
        label: "Survey Date",
        title: "Filter by survey date"
      },
      encounter: {
        label: "Unique Insignia ID",
        title: "Filter by Unique Insignia ID"
      },
      facility: {
        label: "Agency",
        title: "Filter by agency"
      },
      patient: {
        label: "Participant",
        title: "Filter by participant"
      },
      patient_tags: {
        label: "Participant Tags"
      },
      unit: {
        label: "Participant List",
        title: "Filter by participant list"
      }
    },
    search: {
      patient_tasks: {
        empty: {
          message: "There are no {{item}} for this participant due in the next seven days."
        }
      }
    }
  }
}

